import { CASH, FINANCE, LEASE, BALLOON } from '@makemydeal/dr-platform-types';
import type { OfferType } from '@makemydeal/dr-platform-types';
import { getBalloonDealLabel, getCashDealLabel, getFinanceDealLabel, getLeaseDealLabel } from './getDealTypeDropdownLabels';

export type GetDealTypeLabelParams = {
    currentOfferType: OfferType;
    totalAmountDue: number;
    amountPaidByCustomer: number;
    months?: number;
    monthlyPayment: number;
    downPayment: number;
    rateTypeVal: number;
    rateTypeLabel: string;
    isFlexBuyPayment: boolean;
    flexBuyDetails: any;
    cashDown: number;
    isOnePayLease?: boolean;
    dueAtSigning: number;
    balloonAmount: number;
    isCashDownPaymentFieldEnabled?: boolean;
};

export const getDealTypeLabel = (params: GetDealTypeLabelParams) => {
    const {
        currentOfferType,
        totalAmountDue,
        amountPaidByCustomer,
        months,
        monthlyPayment,
        downPayment,
        rateTypeVal,
        rateTypeLabel,
        isFlexBuyPayment,
        flexBuyDetails,
        cashDown,
        isOnePayLease,
        dueAtSigning,
        balloonAmount,
        isCashDownPaymentFieldEnabled
    } = params;

    switch (currentOfferType) {
        case CASH:
            return getCashDealLabel(totalAmountDue, cashDown, isCashDownPaymentFieldEnabled);
        case LEASE:
            return getLeaseDealLabel({
                amountPaidByCustomer,
                months,
                monthlyPayment,
                rateTypeVal,
                rateTypeLabel,
                isOnePayLease,
                dueAtSigning
            });
        case FINANCE:
            return getFinanceDealLabel({
                downPayment,
                months,
                monthlyPayment,
                rateTypeVal,
                rateTypeLabel,
                ...(isFlexBuyPayment ? { flexBuy: flexBuyDetails } : {})
            });
        case BALLOON:
            return getBalloonDealLabel({
                downPayment,
                months,
                monthlyPayment,
                rateTypeVal,
                rateTypeLabel,
                balloonAmount
            });
        default:
            return [];
    }
};
